import { ADVISER, STUDENT, TEACHER } from "./rolesSubtypes";

const userRoles = [
  {
    id: 1,
    role: "Adviser",
    type: ADVISER,
  },
  {
    id: 2,
    role: "Teacher",
    type: TEACHER,
  },
  {
    id: 3,
    role: "Student",
    type: STUDENT,
  },
];

export { userRoles };
